/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, SearchLinkField } from 'framework/ui/field';
import { useCandidateUrl } from 'domain/shared/candidate';

type CandidateSearchLinkFieldProps = {
  idValue?: string;
  idSource?: string;
  source?: string;
  label?: string;
};

const CandidateSearchLinkField = ({ idValue = '', idSource, ...props }: CandidateSearchLinkFieldProps) => {
  const { getSingleEntityUrl } = useCandidateUrl();
  const { getValue: getId } = useFieldHelper({ source: idSource, value: idValue });
  const { getValue } = useFieldHelper<any>(props);

  const id = getId();
  const name = getValue();
  const linkText = name ? `${name.firstName} ${name.lastName}` : id;

  return <SearchLinkField {...props} isInternal value={linkText} url={getSingleEntityUrl(id)} isRowClickable={false} />;
};

export default CandidateSearchLinkField;
